const listTypeEnum = {
  FAVOURITE: 'favourite',
  OKAUCHAN: 'okauchan',
  USER_LIST: 'userList',
} as const;

export default listTypeEnum;

export type ListTypeEnumType = (typeof listTypeEnum)[keyof typeof listTypeEnum];
